<template>
    <el-container class="userOrg">
        <el-aside width="200px">
            <el-header height="35px">部门树</el-header>
            <Department
                ref="treeChild"
                v-if="isShowTree"
                :data="treeData"
                :defaultProps="defaultProps"
                @nodeClick="handleTreeNode"
            />
        </el-aside>
        <el-main>
            <el-container>
                <el-aside style="width: 55%">
                    <div class="tools-bar">
                        <span><el-tag type="primary">部门员工列表</el-tag></span>
                        <div class="tools-search" @keyup.enter="handleSearchInDept">
                            <el-input maxlength="100" v-model.trim="empNameInDept" placeholder="员工姓名">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearchInDept"></el-button>
                            </el-input>
                        </div>
                        <!-- <div class="tools-btn-group">
                            <el-button icon="el-icon-circle-plus" type="primary" @click="handEmployeeDepartmentBatchRemove">批量移除</el-button>
                        </div> -->
                    </div>
                     <template v-if="multiple">
                        <el-table  :data="employeeListInDept" @selection-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="trueName" label="姓名"></el-table-column>
                            <el-table-column prop="departmentName" label="部门"></el-table-column>
                            <el-table-column prop="mobile" label="手机"></el-table-column>
                        </el-table>
                     </template>
                       <template v-else>
                           <el-table  :data="employeeListInDept" highlight-current-row @current-change="handleSelectionChangeInDept" style="width: 100%" v-loading="inDpetloading" stripe>
                            <el-table-column prop="trueName" label="姓名"></el-table-column>
                            <el-table-column prop="departmentName" label="部门"></el-table-column>
                            <el-table-column prop="mobile" label="手机"></el-table-column>
                          </el-table>
                      </template>
                    <!-- 分页 -->
                    <el-row type="flex" justify="end">
                        <el-pagination
                            background
                            layout="total,sizes, prev, pager, next"
                            :total="totalPageNumInDept"
                            :current-page="currentPageInDept"
                            :page-size="pageSizeInDept"
                            :page-sizes="[6, 10, 20, 50, 100, 300, 500, 1000]"
                            @current-change="queryFormDataInDept"
                            @size-change="queryFormDataByPageSize"
                            >
                        </el-pagination>
                    </el-row>
                </el-aside>
                <el-aside style="width: 45%">
                    <div class="tools-bar">
                        <span><el-tag type="success">已选择的员工</el-tag></span>
                        <!-- <div class="tools-search" @keyup.enter="handleSearchUnInDept">
                            <el-input maxlength="100" v-model.trim="empNameUnInDept" placeholder="员工名称">
                                <el-button slot="append" icon="el-icon-search" @click="handleSearchUnInDept"></el-button>
                            </el-input>
                        </div> -->
                        <div class="tools-btn-group">
                            <el-button icon="iconfont icon-other-guolv" type="primary" @click="filterResult">筛选</el-button>
                            <el-button icon="el-icon-remove" type="danger" @click="handleRemoveSelectedUser">移除</el-button>
                        </div>
                    </div>
                    <template v-if="canDrop">
                        <el-table ref="multipleTable" class="canDropTable" row-key="id" :data="selectedUserList" @selection-change="handleSelectionRemovedUser" tooltip-effect="dark" style="width: 100%" v-loading="unInDpetloading" stripe>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="trueName" label="姓名"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" title="移除" circle @click="handleRemoveSelectedUserSingle(scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                    <template v-else>
                         <el-table ref="multipleTable" :data="selectedUserList" @selection-change="handleSelectionRemovedUser" tooltip-effect="dark" style="width: 100%" v-loading="unInDpetloading" stripe>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="trueName" label="姓名"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" title="移除" circle @click="handleRemoveSelectedUserSingle(scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-aside>
                <!-- 过滤已选择的数据 -->
                <el-dialog
                  title="过滤已选择的数据"
                  append-to-body
                  :visible.sync="filterResultDialog">
                    <div class="result-data">
                        <div class="tools-bar">
                            <el-input placeholder="请输入内容" v-model="searchContent" class="input-with-select" style="margin-right: 20px;">
                               <el-button slot="append" icon="el-icon-search" @click="filterResultData"></el-button>
                             </el-input>
                             <el-button icon="el-icon-remove" type="danger" @click="handleRemoveFilterUser(1)">移除</el-button>
                        </div>
                        <el-table ref="multipleTable" class="canDropTable" row-key="id" :data="selectedFilterUserList" @selection-change="handleSelectionRemovedFilterUser" tooltip-effect="dark" style="width: 100%" v-loading="unInDpetloading" stripe>
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="trueName" label="姓名"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="100">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" title="移除" circle @click="handleRemoveFilterUser(scope.row)"></el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                  <span slot="footer" class="dialog-footer">
                      <el-button @click="filterResultDialog = false">取 消</el-button>
                      <el-button type="primary" @click="determineFilter">确 定</el-button>
                  </span>
                </el-dialog>
            </el-container>
        </el-main>
    </el-container>
</template>

<script>
    import { getDepartmentTreeList, getEmployeeListByDepartmentId } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import Department from '@/components/Department';
    import { isEmpty, cloneDeep } from 'lodash';
    import Sortable from 'sortablejs';

    export default {
        mixins: [ mixinsNav ],
        components: {
            Department: Department,
            Sortable
        },
        data () {
            return {
                treeData: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                isShowTree: false,
                treeLoaded: false,
                treeLoading: false,
                empNameInDept: '', // 分配在此部门内员工
                inDpetloading: false,
                employeeListInDept: [], // 分配在此部门内员工
                currentPageInDept: 1, // 当前页码
                pageSizeInDept: 6, // 每页条数
                totalPageNumInDept: 1, // 总页数

                unInDpetloading: false,
                empNameUnInDept: '',
                selectedUserList: [], // 已选择的员工列表数据
                currentPageUnInDept: 1, // 当前页码
                pageSizeUnInDept: 6, // 每页条数
                totalPageNumUnInDept: 1, // 总页数

                employeeDepartment: {
                    employeeId: '',
                    departmentId: ''
                },
                selectMap: new Map(),
                currentDepartmentId: '', // 当前点击的部门节点
                selectedUserIds: '', // 选中的员工ID
                selectedUserNames: '', // 选中的员工名称
                selectedRemovedUserIds: '', // 选中的员工ID
                filterResultDialog: false,
                searchContent: '',
                selectedRemovedFilterUserIds: '',
                selectedFilterUserList: [],
                selectedFilterChargeUserList: []
            };
        },
        props: {
            selectedUser: {
                type: Object,
                default: function () {
                    return {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    };
                }
            },
            filterUsers: {// 需要过滤不显示的人员信息
                type: String,
                default: ''
            },
            multiple: {
                type: Boolean,
                default: false
            },
            canDrop: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // this._initPage();

        },
        mounted () {
            this.rowDrop();
        },
        methods: {
            // 行拖拽
            rowDrop () {
                if (this.canDrop) {
                    // 表格中需要实现行拖动，所以选中tr的父级元素
                    const table = document.querySelector('.canDropTable table tbody');
                    const _this = this;
                    Sortable.create(table, {
                        onEnd ({ newIndex, oldIndex }) {
                            const currRow = _this.selectedUserList.splice(oldIndex, 1)[0];
                            _this.selectedUserList.splice(newIndex, 0, currRow);
                        }
                    });
                }
            },
            async _initPage () {
                this.selectMap = new Map();
                // console.log(this.selectedUser);
                if (!isEmpty(this.selectedUser.selectedUserIds)) {
                    this.selectedUserIds = this.selectedUser.selectedUserIds;
                    this.selectedUserNames = this.selectedUser.selectedUserNames;
                } else {
                    this.selectedUserIds = '';
                    this.selectedUserNames = '';
                }
                this._getListData();
                this.isShowTree = true;
                await this.ensureTreeData();
            },
            async _getListData () {
                await this.handleSearchInDept();
                await this.handleSearchUnInDept();
            },
            async ensureTreeData () {
                if (this.treeLoaded || this.treeLoading) {
                    return;
                }
                this.treeLoading = true;
                try {
                    await this._getTreeData();
                    this.treeLoaded = true;
                } finally {
                    this.treeLoading = false;
                }
            },
            async _getTreeData () {
                let departmentTreeList = await getDepartmentTreeList();
                setTimeout(() => { // 调用子组件的方法
                    this.$refs.treeChild._refreshTreeData(departmentTreeList);
                }, 0);
                this.treeData = departmentTreeList;
                this.isShowTree = true;
            },
            handleTreeNode (data, node, tree) {
                this.currentDepartmentId = data.id;
                this.currentPageInDept = 1;
                this.handleSearchInDept();
                // 初始化变量
                // this.selectedUserIds = '';
                // this.selectedRemovedUserIds = '';
            },
            async handleSearchInDept () {
                this.inDpetloading = true;
                let employeeInDeptListData = await getEmployeeListByDepartmentId(this.currentPageInDept, this.pageSizeInDept, this.currentDepartmentId, this.empNameInDept);
                let sourceUser = cloneDeep(employeeInDeptListData.data);
                let filterUser = [];
                // console.log(sourceUser);
                if (!isEmpty(this.selectedUser.selectedUserIds)) {
                    let selectedIds = this.selectedUser.selectedUserIds.split(',');
                    for (let j = 0; j < selectedIds.length; j++) {
                        this.selectMap.set(selectedIds[j], selectedIds[j]);
                    }
                }
                if (!isEmpty(this.filterUsers)) {
                    let filterIds = this.filterUsers.split(',');
                    let filterMap = new Map();
                    for (let j = 0; j < filterIds.length; j++) {
                        filterMap.set(filterIds[j], filterIds[j]);
                    }
                    for (let i = 0; i < sourceUser.length; i++) {
                        if (!filterMap.has(sourceUser[i].id)) {
                            filterUser.push(sourceUser[i]);
                        }
                    }
                } else {
                    filterUser = sourceUser;
                }
                // console.log(filterUser);
                this.employeeListInDept = filterUser;
                // this.employeeListInDept = employeeInDeptListData.data;
                this.currentPageInDept = employeeInDeptListData.currentPage;
                this.pageSizeInDept = employeeInDeptListData.pageSize;
                this.totalPageNumInDept = employeeInDeptListData.totalPageNum;
                this.inDpetloading = false;
            },
            queryFormDataInDept (currentPageInDept) {
                this.currentPageInDept = currentPageInDept;
                this._getListData();
            },
            queryFormDataByPageSize (pageSize) {
                this.pageSizeInDept = pageSize;
                this._getListData();
            },
            async handleSearchUnInDept () {
                this.unInDpetloading = true;
                if (!isEmpty(this.selectedUserIds)) {
                    let ids = this.selectedUserIds.split(',');
                    let names = this.selectedUserNames.split(',');
                    let selectedData = [];
                    for (var i = 0; i < ids.length; i++) {
                        selectedData.push({id: ids[i], trueName: names[i]});
                    }
                    this.selectedUserList = selectedData;
                } else {
                    this.selectedUserList = [];
                }
                this.unInDpetloading = false;
            },
            queryFormDataUnInDept (currentPageUnInDept) {
                this.currentPageUnInDept = currentPageUnInDept;
                this._getListData();
            },
            async handleRemoveSelectedUser () {
                if (!isEmpty(this.selectedRemovedUserIds)) {
                    let newIds = this.selectedRemovedUserIds.split(',');
                    let ids = this.selectedUserIds.split(',');
                    let names = this.selectedUserNames.split(',');
                    let selectedData = [];
                    this.selectedUserIds = '';
                    this.selectedUserNames = '';
                    let removedMap = new Map();
                    for (var j = 0; j < newIds.length; j++) {
                        removedMap.set(newIds[j], newIds[j]);
                    }
                    for (var i = 0; i < ids.length; i++) {
                        if (!removedMap.has(ids[i])) {
                            selectedData.push({id: ids[i], trueName: names[i]});
                            if (isEmpty(this.selectedUserIds)) {
                                this.selectedUserIds = ids[i];
                                this.selectedUserNames = names[i];
                            } else {
                                this.selectedUserIds = this.selectedUserIds + ',' + ids[i];
                                this.selectedUserNames = this.selectedUserNames + ',' + names[i];
                            }
                        } else {
                            this.selectMap.delete(ids[i]);
                        }
                    }
                    this.selectedUserList = selectedData;
                    // this.selectedUser.selectedUserIds = this.selectedUserIds;
                    // this.selectedUser.selectedUserNames = this.selectedUserNames;
                }
            },
            async handleRemoveSelectedUserSingle (row) {
                // console.log("rowID"+row.id);
                let newIds = row.id;
                let ids = this.selectedUserIds.split(',');
                let names = this.selectedUserNames.split(',');
                let selectedData = [];
                this.selectedUserIds = '';
                this.selectedUserNames = '';
                let removedMap = new Map();
                removedMap.set(newIds, newIds);
                for (var i = 0; i < ids.length; i++) {
                    if (!removedMap.has(ids[i])) {
                        selectedData.push({id: ids[i], trueName: names[i]});
                        if (isEmpty(this.selectedUserIds)) {
                            this.selectedUserIds = ids[i];
                            this.selectedUserNames = names[i];
                        } else {
                            this.selectedUserIds = this.selectedUserIds + ',' + ids[i];
                            this.selectedUserNames = this.selectedUserNames + ',' + names[i];
                        }
                    } else {
                        this.selectMap.delete(ids[i]);
                    }
                }
                this.selectedUserList = selectedData;
            },
            handleSelectionChangeInDept (rows) {
                // this.selectedUserIds = '';
                // this.selectedUserNames = '';
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (!this.selectMap.has(row.id)) {
                                    if (isEmpty(this.selectedUserIds)) {
                                        this.selectedUserIds = row.id;
                                        this.selectedUserNames = row.trueName;
                                    } else {
                                        this.selectedUserIds = this.selectedUserIds + ',' + row.id;
                                        this.selectedUserNames = this.selectedUserNames + ',' + row.trueName;
                                    }
                                    this.selectMap.set(row.id, row.id);
                                }
                            }
                        });
                    } else {
                        this.selectedUserIds = rows.id;
                        this.selectedUserNames = rows.trueName;
                    }
                    this.handleSearchUnInDept();
                }
            },
            handleSelectionRemovedUser (rows) {
                this.selectedRemovedUserIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedUserIds)) {
                                this.selectedRemovedUserIds = row.id;
                            } else {
                                this.selectedRemovedUserIds = this.selectedRemovedUserIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            setChoosedUser () {
                // 按顺序重新赋值
                this.selectedUserIds = '';
                this.selectedUserNames = '';
                this.selectedUserList.forEach(row => {
                    if (row) {
                        if (isEmpty(this.selectedUserIds)) {
                            this.selectedUserIds = row.id;
                            this.selectedUserNames = row.trueName;
                        } else {
                            this.selectedUserIds = this.selectedUserIds + ',' + row.id;
                            this.selectedUserNames = this.selectedUserNames + ',' + row.trueName;
                        }
                    }
                });
                this.selectedUser.selectedUserIds = this.selectedUserIds;
                this.selectedUser.selectedUserNames = this.selectedUserNames;
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            },
            filterResult () {
                this.filterResultDialog = true;
                this.selectedFilterUserList = cloneDeep(this.selectedUserList);
                this.selectedFilterChargeUserList = cloneDeep(this.selectedUserList);
            },
            handleSelectionRemovedFilterUser (rows) {
                this.selectedRemovedFilterUserIds = '';
                if (rows) {
                    rows.forEach(row => {
                        if (row) {
                            if (isEmpty(this.selectedRemovedFilterUserIds)) {
                                this.selectedRemovedFilterUserIds = row.id;
                            } else {
                                this.selectedRemovedFilterUserIds = this.selectedRemovedFilterUserIds + ',' + row.id;
                            }
                        }
                    });
                }
            },
            determineFilter () {
                this.selectedUserList = cloneDeep(this.selectedFilterChargeUserList);
                this.filterResultDialog = false;
            },
            handleRemoveFilterUser (o) {
                let arr = [];
                let brr = [];
                let selIds = '';
                if (o !== 1) {
                    selIds = o.id;
                } else {
                    selIds = this.selectedRemovedFilterUserIds.split(',');
                }
                for (var i = 0; i < this.selectedFilterUserList.length; i++) {
                    var obj = this.selectedFilterUserList[i];
                    if (selIds.indexOf(obj.id) === -1) {
                        arr.push(obj);
                    }
                }
                for (var j = 0; j < this.selectedFilterChargeUserList.length; j++) {
                    var obj1 = this.selectedFilterChargeUserList[j];
                    if (selIds.indexOf(obj1.id) === -1) {
                        brr.push(obj1);
                    }
                }
                this.selectedFilterUserList = arr;
                this.selectedFilterChargeUserList = brr;
                this.selectedFilterUserList = cloneDeep(this.selectedFilterChargeUserList);
                this.searchContent = '';
            },
            filterResultData () {
                if (this.searchContent === '') {
                    this.selectedFilterUserList = cloneDeep(this.selectedFilterChargeUserList);
                } else {
                    let arr = [];
                    for (var i = 0; i < this.selectedFilterUserList.length; i++) {
                        var obj = this.selectedFilterUserList[i];
                        if (obj.trueName.indexOf(this.searchContent) !== -1) {
                            arr.push(obj);
                        }
                    }
                    this.selectedFilterUserList = arr;
                }
            }
        }
    };
</script>

<style lang="less">
    .userOrg {
        height: 365px;
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UserOrg/UserOrg.vue